













import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { IReportGroup, ReportGroup } from "@/models/report-group.entity";
import { ReportGroupModule } from "@/store/modules/report-group.store";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import ReportGroupDetail from "@/components/report/group/ReportGroupDetail.vue";
import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";

@Component({
  components: {
    TheLayoutPortal,
    ReportGroupDetail,
    LatestEntriesCardEmpty
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class ReportGroupDetailView extends mixins(PartnerFallbackMixin) {
  get partnerId(): string {
    return this.$route.params.partnerId;
  }

  get reportGroupId(): string {
    return this.$route.params.reportGroupId;
  }

  isLoading = false;

  reportGroup: IReportGroup | null = null;

  async mounted() {
    await this.trySetByRouteOrDefault();

    const reportGroup =
      ReportGroupModule.maps.id.get(this.reportGroupId)[0] ??
      new ReportGroup({
        id: this.reportGroupId,
        partnerId: this.partnerId
      });

    try {
      this.isLoading = true;
      await reportGroup.fetch();
      this.reportGroup = reportGroup;
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }
}
